import Joi from '@hapi/joi';

export default Joi.object({
    first_name: Joi.string()
        .required()
        .messages({
            'string.empty': 'Please enter a first name',
            'any.required': 'Please enter a first name',
        }),
    last_name: Joi.string()
        .trim()
        .required()
        .messages({
            'string.empty': 'Please enter a last name',
            'any.required': 'Please enter a last name',
        }),
    email: Joi.string()
        .trim()
        .required()
        .messages({
            'string.empty': 'Please enter an email',
            'any.required': 'Please enter an email',
        }),
    global_role: Joi.string()
        .trim()
        .required()
        .messages({
            'string.empty': 'Please select a role',
            'any.required': 'Please select a role',
        }),
});
